let lenisInstance = null;

export const setLenis = (lenis) => {
  lenisInstance = lenis;
};

export const getLenis = () => lenisInstance;

export const scrollToSection = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
